export default () => ({
  empresa: {},
  config: {},
});
